<div class="subject cursor-pointer" [class.files-attached]="hasAttachments">
  <span>{{ subject }}</span>
  <i class="icon ic-md ic-attachment cursor-pointer"></i>
</div>
